import { IAuthRepository } from '../../domain/repositories/IAuthRepository';
import { UserDTO } from '../dto/UserDTO';
import { UserMapper } from '../mappers/UserMapper';

export interface GetCurrentUserResponse {
  user: UserDTO | null;
}

/**
 * Get Current User Use Case
 * Retrieves the currently authenticated user
 */
export class GetCurrentUserUseCase {
  constructor(private readonly authRepository: IAuthRepository) {}

  async execute(): Promise<GetCurrentUserResponse> {
    console.log('GetCurrentUserUseCase: Starting...');
    const user = await this.authRepository.getCurrentUser();
    console.log('GetCurrentUserUseCase: User fetched:', user ? 'Found' : 'Not found');

    const dto = user ? UserMapper.toDTO(user) : null;
    console.log('GetCurrentUserUseCase: DTO:', dto);

    return {
      user: dto,
    };
  }
}
